package org.gstechnovos.jexonplastech.components.widgets.styles

import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.gstechnovos.jexonplastech.theme.toSitePalette
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

val GlobalCtaContainerStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier
            .fillMaxWidth()
            .backgroundColor(palette.brand.primaryBlue)
    }
}

val CtaButtonStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier
            .backgroundColor(palette.custom.white)
            .color(palette.brand.primaryBlue)
            .padding(leftRight = 32.px, topBottom = 16.px)
            .borderRadius(8.px)
            .fontWeight(com.varabyte.kobweb.compose.css.FontWeight.Bold)
            .fontSize(18.px)
            .display(DisplayStyle.InlineBlock)
            .textDecorationLine(com.varabyte.kobweb.compose.css.TextDecorationLine.None)
            .styleModifier { property("text-decoration", "none !important") }
            .transition(
                Transition.of("transform", 0.3.s),
                Transition.of("box-shadow", 0.3.s),
                Transition.of("background-color", 0.3.s)
            )
    }
    hover {
        Modifier
            .backgroundColor(palette.custom.lightGray)
            .translateY((-4).px)
            .boxShadow(0.px, 10.px, 20.px, color = palette.custom.darkText.toRgb().copyf(alpha = 0.2f))
            .textDecorationLine(com.varabyte.kobweb.compose.css.TextDecorationLine.None)
            .styleModifier { property("text-decoration", "none !important") }
    }
}